import React from 'react';

import { Urls } from 'js/src/client';
import LogoImages from 'js/src/components/common/LogoImages';
import { logoImagesLight } from 'js/src/components/public-pages/homepage-data';

const Sidebar = React.memo(function Sidebar() {
    return (
        <div className="intro-sidebar">
            <a href={Urls.HOME}>
                <img
                    className="logo-image py-l5-24"
                    src="https://cdn.lumen5.com/lumen5-site-images/2025-website-assets/logos/Lumen5-Reverse-White.webp"
                    alt="Lumen5 Logo"
                    loading="eager"
                />
            </a>
            <div className="text-white">
                <h3>
                    <strong>Join over 5,000,000 companies using Lumen5 to create videos</strong>
                </h3>
                <h4>
                    Turn blogs, articles, scripts, and ideas into videos in minutes for marketing,
                    communications, and education.
                </h4>
            </div>

            <div className="logo-container">
                <LogoImages logos={logoImagesLight} lazyLoad={false} />
            </div>
        </div>
    );
});

export default Sidebar;
